import React from "react";
import MealCard from "@/components/landing/MealCard";

export default function WeeklyMenu({ meals, cart, onQtyChange, onMealImageClick }) {
    return (
        <section
            id="menu"
            data-testid="weekly-menu-section"
            className="bg-cream py-20 md:py-28 px-6 sm:px-8"
        >
            <div className="max-w-6xl mx-auto">
                <div className="text-center max-w-2xl mx-auto reveal">
                    <p
                        data-testid="weekly-menu-tagline"
                        className="mb-6 font-serif italic text-xl sm:text-2xl md:text-3xl text-forest leading-snug"
                    >
                        Healthy Caribbean Meals That Still Taste Like Home.
                    </p>
                    <span
                        data-testid="menu-pill-label"
                        className="inline-block px-4 py-1.5 rounded-full bg-mint text-forest text-xs font-bold tracking-widest uppercase"
                    >
                        This Week's Menu
                    </span>
                    <h2 className="mt-6 font-serif font-black text-4xl sm:text-5xl md:text-6xl leading-tight text-navy">
                        Caribbean dishes,{" "}
                        <span className="text-forest italic">
                            freshly prepped
                        </span>{" "}
                        for you
                    </h2>
                    <p className="mt-5 text-base sm:text-lg text-muted2 leading-relaxed">
                        Tap any meal's photo or stepper to open the full menu
                        and build your box.
                    </p>
                </div>

                {meals.length === 0 ? (
                    <div className="mt-16 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 md:gap-10">
                        {[0, 1, 2, 3, 4].map((i) => (
                            <div
                                key={i}
                                className="bg-white rounded-[20px] h-[520px] animate-pulse opacity-50"
                            />
                        ))}
                    </div>
                ) : (
                    <div className="mt-16 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 md:gap-10">
                        {meals.map((meal, idx) => (
                            <div
                                key={meal.id}
                                className="reveal"
                                style={{ transitionDelay: `${idx * 80}ms` }}
                            >
                                <MealCard
                                    meal={meal}
                                    qty={cart[meal.id] || 0}
                                    onQtyChange={(q) =>
                                        onQtyChange(meal.id, q)
                                    }
                                    onImageClick={
                                        onMealImageClick
                                            ? () => onMealImageClick(meal.id)
                                            : null
                                    }
                                />
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
}
